import { forwardRef } from 'react';
import './styles.scss';

const SeoTextShop = forwardRef<HTMLElement>((_, ref) => (
  <section ref={ref} className='seo-text-section'>
    <div className='seo-text-section__container'>
      <h2 className='seo-text-section__title'>
        Интернет-магазин вкусных продуктов
      </h2>

      <div className='seo-text-section__content'>
        <p className='seo-text-section__text'>
          Деликатеска — это сеть гастрономов у дома, где можно купить свежую
          рыбу, морепродукты, деликатесы и повседневные товары в удобном
          формате. Наши магазины продуктов включают розничные точки в Москве и
          области и интернет-магазин, чтобы вы могли выбирать подходящий способ
          покупки. В ассортимент входят свежие и замороженные продукты,
          уникальные полуфабрикаты собственного производства, чтобы готовить
          дома быстро и вкусно, продукты для особых случаев. Сеть постоянно
          расширяет ассортимент и поддерживает высокое качество продуктов
          питания.
        </p>

        <p className='seo-text-section__text'>
          На странице магазинов вы найдете адрес, карту проезда, актуальное
          время работы и другую полезную информацию. Если удобнее оформлять
          заказ онлайн, доступна бесплатная доставка по Москве и самовывоз из
          магазинов:
        </p>

        <ul className='seo-text-section__list'>
          <li className='seo-text-section__list-item'>
            — через 15 минут, если выбирать товары из ассортимента розничного
            магазина;
          </li>
          <li className='seo-text-section__list-item'>
            — вечером или на следующий день при заказе из ассортимента
            интернет-магазина.
          </li>
        </ul>

        <p className='seo-text-section__text'>
          Мы помогаем экономить время: заказать продукты можно за несколько
          минут, а в магазине вам всегда помогут сориентироваться консультанты.
          Если сомневаетесь в выборе, смотрите честные отзывы покупателей на
          сайте. Деликатеска работает для тех, кто ценит качество, широкий выбор
          и удобный сервис.
        </p>
      </div>
    </div>
  </section>
));

export default SeoTextShop;
